/// Top-of-screen readback toast stack. Acts like a tiny radio
/// chatter log: each command (or, future, aircraft check-in) pushes
/// one quoted line which fades after a short TTL. Newest sits at the
/// top of the stack so the most recent transmission is most visible.
///
/// The push path also drives the audio side: a mic-key blip + Web
/// Speech API readback for every transmission. Both no-op when the
/// player has the voice toggle off.

import { create } from 'zustand'
import { playBlip } from '../audio/RadioBlip'
import { isVoiceEnabled, speak } from '../audio/VoiceManager'

const DEFAULT_TTL_MS = 4500
const MAX_VISIBLE = 8

export interface ReadbackMessage {
  id: number
  text: string
}

interface ReadbackState {
  messages: ReadbackMessage[]
  push(text: string, ttlMs?: number): void
  clearAll(): void
}

let counter = 0

export const useReadbackStore = create<ReadbackState>((set) => ({
  messages: [],
  push: (text, ttlMs = DEFAULT_TTL_MS) => {
    counter += 1
    const id = counter
    set((s) => ({
      messages: [{ id, text }, ...s.messages].slice(0, MAX_VISIBLE),
    }))
    if (isVoiceEnabled()) {
      playBlip()
      speak(text)
    }
    window.setTimeout(() => {
      set((s) => ({ messages: s.messages.filter((m) => m.id !== id) }))
    }, ttlMs)
  },
  clearAll: () => set({ messages: [] }),
}))
